import { render, staticRenderFns } from "./shipment-form.vue?vue&type=template&id=269ae61c&scoped=true"
import script from "./shipment-form.vue?vue&type=script&lang=js"
export * from "./shipment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ae61c",
  null
  
)

export default component.exports